const bankRankList = () =>
  import(
    /* webpackChunkName: "bankRank-bankRankList" */ 'page/platform/bankRank/bankRankList.vue'
  )

let routes = [
  {
    path: '/bankRankList/:choiceId',
    component: bankRankList,
    meta: {
      pageName: '榜单列表',
      business: '平台',
      title: '榜单列表'
    }
  }
]

export default routes
